import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=88dcf5bc"
import script from "./ChatPanel.vue?vue&type=script&lang=js"
export * from "./ChatPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports